import * as React from 'react';
import PublishedCalendarsFull from './components/PublishedCalendarsFull';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option } from 'owa-options-core';
import isSharedCalendarsOptionDirty from './utils/isSharedCalendarsOptionDirty';
import saveSharedCalendarOption from './orchestration/saveSharedCalendarOption';
import discardSharedCalendarOption from './data/mutators/discardSharedCalendarOption';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';

const PublishedCalendarsOption: Option = {
    key: 'publishedCalendars',
    titleStringKey: 'optionTitle_publishACalendar',
    searchTermsStringKey: 'optionTitle_publishACalendar',
    fullOptionFormSettings: {
        render: () => <PublishedCalendarsFull />,
        isDirty: isSharedCalendarsOptionDirty,
        onSave: saveSharedCalendarOption,
        onDiscard: discardSharedCalendarOption,
    },
    isHidden: () => {
        return !isFeatureEnabled('cal-publishing-settings') || IsShadowMailboxUser();
    },
    allowedOptionKeys: ['CalendarPublishing'],
};

export default PublishedCalendarsOption;
